import React, { useState, useEffect } from "react";
import styled from "styled-components";

import { handlePlatformPayment } from "./utils/paymentUtils";
import { transferToNative, WebAppBridge } from "@src/lib/WebAppBridge";
import { useTicketPackageList } from "@src/hooks/deungi/useTicketPackageList";
import { TicketPackageListResponseDto } from "@src/hooks/deungi/dto/PackageList.dto";

import TicketCountBox from "./components/ticketCountBox";
import { TICKET_TYPE_STRING } from "@src/components/deungi/common/enum";

import { Accordion, AccordionDetails, AccordionSummary, Divider, styled as mstyled } from "@mui/material";
import { ownerCheckTenIcon, ownerCheckThirtyIcon, ownerCheckFiftyIcon, ownerCheckHundredIcon, ownerCheckSingleIcon } from "./ui";
import ico_arrow_back from "@src/assets/ico_arrow_back.png";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";

interface ResponseData {
    list: Array<TicketPackageListResponseDto>;
}

const OwnerCheckChargePayment = () => {
    // Service Explanation AccordionFlag State
    const [accordionFlag, setAccordionFlag] = useState({
        deungi: false,
    });

    // Checking OS Type
    var Agent = navigator.userAgent.toLowerCase();
    let osType = "";

    if (Agent.indexOf("android") > -1) {
        osType = "android";
    } else if (Agent.indexOf("iphone") > -1) {
        osType = "ios";
    }

    const [responseData, setResponseData] = useState<ResponseData | null>(null);

    // PackageClick Handler -> transferToNative
    const handlePackageClick = (item: TicketPackageListResponseDto) => {
        handlePlatformPayment(osType, item, TICKET_TYPE_STRING.OWNER_CHECK_TICKET);
    };

    const getIcon = (quantity: number) => {
        switch (true) {
            case quantity === 10:
                return ownerCheckTenIcon;
            case quantity === 30:
                return ownerCheckThirtyIcon;
            case quantity === 50:
                return ownerCheckFiftyIcon;
            case quantity === 100:
                return ownerCheckHundredIcon;
            default:
                return ownerCheckSingleIcon;
        }
    };

    const fetchData = async () => {
        try {
            const response = await useTicketPackageList(osType === "android" ? 6 : 7);
            setResponseData(response.data);
        } catch (error) {
            console.error("Error fetching ticket package list:", error);
        }
    };

    // Fetch ticket package data
    useEffect(() => {
        fetchData();
    }, []);

    return (
        <Layout>
            <Header>
                <div
                    className="prevBtn"
                    onClick={() => {
                        transferToNative("done", "closeWebView");
                    }}
                >
                    <img src={ico_arrow_back} />
                </div>
                <Title>충전하기</Title>
            </Header>
            <TicketCountBox />
            <Container>
                <div className="scrollBox">
                    <PackageListBox>
                        <div className="packageBox">
                            <div className="titleBox">
                                <h3>소유자 확인 이용권</h3>
                            </div>
                            {responseData &&
                                responseData.list
                                    ?.filter((item) => item.type === TICKET_TYPE_STRING.OWNER_CHECK_TICKET)
                                    .map((item, idx) => {
                                        return (
                                            <div
                                                key={item.code}
                                                id={item.code}
                                                className="items"
                                                onClick={() => handlePackageClick(item)}
                                            >
                                                <img
                                                    src={getIcon(item.quantity ?? 1)}
                                                    alt="소유자 확인 이용권 아이콘"
                                                    width={50}
                                                    height={50}
                                                />
                                                <div>
                                                    <span>{item.name}</span>
                                                    {item.discountString ? <small>{item.discountString}</small> : <></>}
                                                </div>
                                                <span>{`${item.discountPrice.toLocaleString()}원`}</span>
                                            </div>
                                        );
                                    })}
                        </div>
                    </PackageListBox>
                    <div className="px-4 pb-[100px]">
                        <TabAccordion
                            square
                            expanded={accordionFlag.deungi}
                            onChange={() => {
                                setAccordionFlag((prev) => {
                                    return {
                                        ...prev,
                                        deungi: !prev.deungi,
                                    };
                                });
                            }}
                        >
                            <AccordionSummary expandIcon={<ExpandMoreRoundedIcon />}>
                                <div>소유자 확인 서비스 이용권 충전 이용안내</div>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Divider sx={{ margin: "0 18px", padding: 0 }} />
                                <div>
                                    - 소유자 확인 서비스 이용권 사용 시 확인을 요청한 시점에 실시간으로 발급된 소유자 정보를
                                    확인할 수 있습니다. <br />
                                    - 결제를 통한 이용권, 충전한 이용권의 유효기간은 결제시점을 기준으로 1년입니다. <br />
                                    - 법원 등기소 정기 서비스 점검으로 인해 일시적으로 확인이 제한될 수 있습니다. <br />- 이용권
                                    충전 취소는 결제 후 7일 내 이용권 미사용 시 가능하며, 결제 후 7일 경과 또는 서비스 이용 시에는
                                    환불이 불가능합니다. <br />- 충전 취소 및 환불 요청은 ‘내정보
                                    {">"} 고객센터{">"}
                                    자주묻는질문’에서 가능합니다. <br />
                                    - 정기구독 결제 혹은 무료로 제공된 이용권은 취소 및 환불 대상이 아닙니다. <br />
                                    - 이용권 사용은 유효기간이 임박한 순으로 먼저 사용됩니다. <br />
                                    - 비구독 회원의 경우, 회원가입 후 이용권을 구매 해야만 서비스를 이용하실 수 있습니다. <br />-
                                    무료체험 회원의 경우, 이용권을 구매 해야만 서비스를 이용하실 수 있습니다.
                                </div>
                            </AccordionDetails>
                        </TabAccordion>
                    </div>
                </div>
            </Container>
        </Layout>
    );
};

const TabAccordion = mstyled(Accordion)({
    boxShadow: "none",
    backgroundColor: "#FBF8F8",
    borderRadius: "14px",
    marginTop: "24px !important",

    "&:before": {
        display: "none",
    },
    "& .MuiAccordionSummary-expandIconWrapper": {
        color: "#0c0c0c",
    },
    "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
        transform: "rotate(180deg)",
    },

    "& .MuiAccordionSummary-root.Mui-expanded": {
        margin: 0,
        minHeight: 0,
    },
    "& .MuiDivider-root": {
        border: 0,
    },
    "& .MuiAccordionSummary-content": {
        margin: 0,
    },
    "& .MuiAccordionSummary-content.Mui-expanded": {
        margin: 0,
    },
    "& .MuiAccordionSummary-root": {
        backgroundColor: "#FBF8F8",
        color: "#0c0c0c",
        padding: "14px",
        fontSize: "14px",
        lineHeight: "26px",
        translation: "all 0.2s",
        borderRadius: "14px",
    },
    "& .MuiAccordionDetails-root": {
        fontSize: "12px",
        color: "#a3a3a3",
        padding: "0 14px",
        marginBottom: "14px",
        border: 0,
        lineHeight: "20px",
    },
});

const PackageListBox = styled.div`
    .packageBox {
        padding: 14px;
        transition: all 0.2s ease;
        background: #f6faff;
        .titleBox {
            position: relative;
            display: flex;
            align-items: center;
            margin-bottom: 14px;

            & > h3 {
                font-size: 18px;
                font-weight: 700;
            }
            & > img {
                width: 20px;
                height: 20px;
                margin-left: 8px;
                cursor: pointer;
            }
        }
        .items {
            display: flex;
            align-items: center;
            width: 100%;
            background: #fff;
            border: 1px solid #c9c9c9;
            border-radius: 14px;
            font-size: 16px;
            box-sizing: border-box;
            padding: 14px;
            margin-bottom: 14px;
            transition: all 0.2s ease;
            cursor: pointer;

            & > img {
                width: 50px;
                height: 50px;
            }
            & > div {
                display: flex;
                flex-direction: column;
                margin-left: 14px;

                & > span {
                    word-break: keep-all;
                    line-height: 1.1;
                }
                & > small {
                    margin-top: 7px;
                    color: #ff0000;
                }
            }
            & > span {
                width: fit-content;
                min-width: 80px;
                height: 40px;
                background: #fff;
                border-radius: 8px;
                margin-left: auto;
                text-align: center;
                line-height: 40px;
                word-break: keep-all;
            }
        }
    }
`;

const Container = styled.div`
    position: relative;
    height: 100vh;
    .scrollBox {
        height: calc(100vh - 147px);
        overflow: hidden auto;
        padding-bottom: 100px;
        box-sizing: border-box;
        border-top: 4px solid #f0f0f0;
        background-color: #fff;
    }
`;

const Layout = styled.div`
    position: relative;
    transition: all 0.3s ease-in;
    width: 100%;
    height: auto;
    user-select: none;
    animation: fadeIn 0.5s forwards;
`;

const Header = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    padding-top: 1rem;
    padding-bottom: 1rem;

    .prevBtn {
        position: absolute;
        left: 5px;
        top: 50%;
        transform: translateY(-50%);

        display: flex;
        justify-content: center;
        align-items: center;

        width: 40px;
        height: 40px;

        & > img {
            width: 10px;
            height: 17px;
        }
    }
`;

const Title = styled.div`
    font-size: 18px;
    font-weight: 700;
`;

export default OwnerCheckChargePayment;
